import { render, staticRenderFns } from "./AddApirequestPage.vue?vue&type=template&id=03d157bc&"
import script from "./AddApirequestPage.vue?vue&type=script&lang=js&"
export * from "./AddApirequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports